import { render, staticRenderFns } from "./AttachedFile.vue?vue&type=template&id=217edcea&"
import script from "./AttachedFile.vue?vue&type=script&lang=js&"
export * from "./AttachedFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports